/**
    * @description      : 
    * @author           : 
    * @group            : 
    * @created          : 01/09/2025 - 14:27:14
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 01/09/2025
    * - Author          : 
    * - Modification    : 
**/
import React, { useState } from "react";
import TitleBanner from "../../components/titleBanner";
import Navbar from "../../components/Navbar";
import {Frontend,Backend,Web} from "./data"
import Footer from "../../components/footer";
import { grey } from "@mui/material/colors";
import { Box, Grid, IconButton, SwipeableDrawer, styled, useMediaQuery, useTheme } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import PageTitle from "../../components/PageTitle";

const drawerBleeding = 0;
const Root = styled("div")(({ theme }) => ({
  height: "100%",
  display:"none",
  backgroundColor:
    theme.palette.mode === "light"
      ? grey[100]
      : theme.palette.background.default,
}));
 
const StyledSwipeableDrawer = styled(SwipeableDrawer)(({ theme }) => ({
  ".MuiPaper-root": {
    height: `calc(50% - ${drawerBleeding}px)`,
    overflow: "visible",
    backgroundColor: "#e6f5ff",
    borderRadius: "20px",
    width: "90%",
    position: "absolute",
    bottom: "20px",
    margin: "auto",
  },
}));


const Technologies: React.FC = () => {
  const [selectedItem,setSelectedItem] = useState({title:"JavaScript", text:"If none of them suit you, or you feel you could help us in other ways, please fill out the form below or contact us directly at carrers@courtney.lk",type:"frontEnd_0"})
  const [animationClass, setAnimationClass] = useState("slide-in");
  const [open, setOpen] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
 

  const toggleDrawer = (newOpen: boolean) => () => {
    if (isMobile) {
      setOpen(newOpen);
    }
  };

  const handleSelect = (title: string, text: string, index: number, type: string) => {
    setAnimationClass("slide-out"); 
    setTimeout(() => {
      setSelectedItem({ title, text, type: `${type}_${index}` });
      setAnimationClass("slide-in"); 
      if (isMobile) {
        setOpen(true);
      }
    }, 100); 
  };


  return (
    <React.Fragment>
      <PageTitle title="Technologies" />
      <Navbar />
      <TitleBanner
        title="Technologies"
        text="We specialize in helping you build a team of expert developers."
      />
      
      <Grid padding={2} container className="technologies" justifyContent={"space-around"} marginTop={10} marginBottom={21}>
        <Grid item sm={5.5} md={7} className="grid_1_left">
        <h1>FrontEnd</h1>
         <section className="iconSection">
          {Frontend.map((item,index)=>{
           return(<Grid className={selectedItem.type === `frontEnd_${index}` ? "selectedIcon" : " "} onClick={()=>{handleSelect(item.title,item.text,index,"frontEnd")}} sm={5.5} md={3.5} lg={3} component={"div"} key={`${item.title}_${index}`}><img data-aos="flip-left" src={item.icon} loading="lazy" draggable="false" alt={`${item.title} logo`} className="item-icon" /></Grid>)
          })}
        </section>
        <h1>BackEnd</h1>
         <section className="iconSection">
          {Backend.map((item,index)=>{
           return(<Grid className={selectedItem.type === `backEnd_${index}` ? "selectedIcon" : " "} onClick={()=>{handleSelect(item.title,item.text,index,"backEnd")}} sm={5.5} md={3.5} lg={3} component={"div"} key={`${item.title}_${index}`}><img data-aos="flip-left" src={item.icon} loading="lazy" draggable="false" alt={`${item.title} logo`} className="item-icon" /></Grid>)
          })}
        </section>
        <h1>Web</h1>
         <section className="iconSection">
          {Web.map((item,index)=>{
           return(<Grid className={selectedItem.type === `Web_${index}` ? "selectedIcon" : " "} onClick={()=>{handleSelect(item.title,item.text,index,"Web")}}  sm={5.5} md={3.5} lg={3} component={"div"} key={`${item.title}_${index}`}><img data-aos="flip-left" src={item.icon} loading="lazy" draggable="false" alt={`${item.title} logo`} className="item-icon" /></Grid>)
          })}
        </section>
        </Grid>
        <Grid display={isMobile? "none" : "block"} sm={6} md={4} className="grid_1_right" item >
          <h1  className={`${animationClass}`}>{selectedItem.title}</h1>
          <p className={`${animationClass}`}>{selectedItem.text}</p>
        </Grid>
        
      <Root>  
        <StyledSwipeableDrawer
          anchor="bottom"
          open={isMobile? open : false}
          onClose={toggleDrawer(false)}
          onOpen={toggleDrawer(true)}
          swipeAreaWidth={drawerBleeding}
          disableSwipeToOpen={true}
          ModalProps={{
            keepMounted: true,
          }}
        >
          <IconButton onClick={()=>{setOpen(false)}} sx={{cursor:"pointer"}}>
          <CloseIcon  fontSize="medium" className="ms-auto mt-3 me-3 border-3  "/>
          </IconButton>
          <Box component={"div"} paddingY={1} paddingX={2} className="technologiesDrawerItem">
            <h1>{selectedItem.title}</h1>
            <p>{selectedItem.text}</p>
          </Box>
        </StyledSwipeableDrawer>
      </Root>
      </Grid>
      <Footer/>
    </React.Fragment>
  );
};

export default Technologies;
